import React, { useState, useEffect } from 'react'
import AudienceProviderInfoHolder from "./Styles/AudienceProviderInfoStyle";
import genericAudience from "../images/generic-audience-icon.png";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";

const AudienceProviderInfo = ({ displays, view = 'quantitative' }) => {
    const { t } = useTranslation();

    const [providerList, setProviders] = useState([]);

    const screenOwnerProviderId = 2;

    const removeDuplicates = (arr) => {
        return Array.from(new Set(arr.map(JSON.stringify)), JSON.parse);
    };

    const getProviderName = (provider) => {
        return provider.id !== screenOwnerProviderId ? provider.stylized_name : t('display owner');
    };

    const getProviderImg = (provider) => {
        return provider && provider.image ? provider.image : genericAudience;
    };

    const sanitizeDisplayProviders = () => {
        // If a display has no provider, it will be assigned to the screen owner provider
        return displays.map(d => {
            if(view === 'qualitative') {
                if (!d.qualitative_audience_provider_id) {
                    return {
                        ...d,
                        qualitative_audience_provider_id: screenOwnerProviderId,
                        qualitative_audience_provider: { id: screenOwnerProviderId },
                    };
                }
            } else if (view === 'quantitative') {
                if (!d.audience_provider_id) {
                    return {
                        ...d,
                        audience_provider_id: screenOwnerProviderId,
                        audience_provider: { id: screenOwnerProviderId },
                    };
                }
            }
            return d; // Return the original object if no changes are needed
        });
      };

    useEffect(() => {
        if (displays && displays.length > 0) {
            const auxDisplays = sanitizeDisplayProviders();
            const uniqueProviders = removeDuplicates(
                view === 'qualitative' ?
                auxDisplays.filter(d => d.qualitative_audience_provider_id).map(d => d.qualitative_audience_provider) :
                view === 'quantitative' ?
                auxDisplays.filter(d => d.audience_provider_id).map(d => d.audience_provider) : null
            );
            setProviders(uniqueProviders);
        }
    }, [displays, view]);

    return (
        <AudienceProviderInfoHolder>
                {
                providerList.length && (
                    <div className="audience-provider-info-component">
                        {providerList.length < 2 && (
                            <div className="provider-container">
                                <img src={getProviderImg(providerList[0])} className="provider-image" />
                                <div>
                                    {displays && displays.length == 1 ? t("Audience data for this screen provided by") : t("Audience data for these screens provided by")} {' '}
                                    {providerList[0].url ? (
                                        <a href={providerList[0].url} target="_blank">{getProviderName(providerList[0])}</a>
                                    ) : (
                                        <span>{getProviderName(providerList[0])}</span>
                                    )}
                                </div>
                            </div>
                        )}
                        {providerList.length >= 2 && (
                            <div className="provider-container">
                                {displays && displays.length == 1 ? t("Audience data for this screen provided by") : t("Audience data for these screens provided by")} {' '}:
                                <div className="external-provider-names">
                                    {providerList.map((provider, index) => (
                                        <span key={index}>
                                            {index !== 0 && <span>&nbsp;/&nbsp;</span>}
                                            <img src={getProviderImg(provider)} className="small-provider-image" />
                                            {provider.url ? (
                                                <a href={provider.url} target="_blank">{getProviderName(provider)}</a>
                                            ) : (
                                                <span>{getProviderName(provider)}</span>
                                            )}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
        </AudienceProviderInfoHolder>
)};

export default AudienceProviderInfo;